
export function sendAnalyticsEvent(category, action, extra) {
}

export function identifyMixPanel(id) {
  try {
  } catch (error) {
    console.error('identifyMixPanel', error);
  }
}

export function setMixPanelUserInfo(props) {
  try {
  } catch (e) {
    console.warn('setMixPanelUserInfo', e);
  }
}

document.addEventListener('deviceready', () => {
  try {
  } catch (error) {
    console.error('deviceready', error);
  }
}, false);

document.addEventListener('resume', () => {
  try {
    if(!document.isUsingCamera){
    }
  } catch (error) {
    console.error('resume', error);
  }
}, false);

document.addEventListener('pause', () => {
  try {
    if(!document.isUsingCamera){
    }
  } catch (error) {
    console.error('pause', error);
  }
}, false);

window.addEventListener('unload', () => {
  try {
  } catch (error) {
    console.error('unload', error);
  }
});